import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  NbAutocompleteModule,
  NbInputModule,
  NbPopoverModule,
  NbIconModule,
} from "@nebular/theme";
import { TyaAutocompleteComponent } from "./tya-autocomplete.component";
import { NbEvaIconsModule } from "@nebular/eva-icons";

@NgModule({
  declarations: [TyaAutocompleteComponent],
  imports: [
    FormsModule,
    CommonModule,
    NbAutocompleteModule,
    NbInputModule,
    NbPopoverModule,
    NbEvaIconsModule,
    NbIconModule,
  ],
  exports: [TyaAutocompleteComponent],
})
export class TyaAutocompleteModule {}
